<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="thunderbolts">
<p style="margin-top: 250px; text-align: center;">“The times, they are a-changin’.”</p><br/>
<p style="text-align: right;">Bob Dylan</p>
<p style="text-align: right;">Greenwich Village, NY</p>
<p style="text-align: right;">December 1963</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0012.vue?57999f98